/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const adminRoutes = {
  path: '/administrator',
  component: Layout,
  redirect: '/administrator/users',
  name: 'Administrator',
  alwaysShow: true,
  meta: {
    title: 'administrator',
    icon: 'avatar',
    permissions: [
      'user_view',
      'employee_view',
      'role_permission_view',
      'supplier_view',
      'client_view',
      'subcontractor_view',
      'department_view',
      'activity_view',
    ],
  },
  children: [
    /** User managements */
    {
      path: 'users/edit/:id(\\d+)',
      component: () => import('../views/users/UserProfile'),
      name: 'UserProfile',
      meta: {
        title: 'userProfile',
        noCache: true,
        permissions: ['user_edit'],
      },
      hidden: true,
    },
    {
      path: 'users',
      component: () => import('../views/users/List'),
      name: 'UserList',
      meta: { title: 'users', icon: 'user', permissions: ['user_view'] },
    },
    {
      path: 'edit/user/permission/:id(\\d+)',
      component: () => import('../views/users/components/Permisions'),
      name: 'EditUserPermission',
      meta: {
        title: 'EditPermission',
        icon: 'edit',
        permissions: ['user_edit'],
      },
      hidden: true,
    },
    // employees management

    {
      path: 'employees',
      component: () => import('../views/employees/List'),
      name: 'EmployeeList',
      meta: {
        title: 'EmployeeList',
        icon: 'Memo',
        permissions: ['employee_view'],
      },
    },
    {
      path: 'employees/edit/:id(\\d+)',
      component: () => import('../views/employees/components/EditEmployee'),
      name: 'EmployeeProfile',
      meta: {
        title: 'EmployeeProfile',
        noCache: true,
        permissions: ['employee_edit'],
      },
      hidden: true,
    },
    /** Role and permission */
    {
      path: 'roles',
      component: () => import('../views/role-permission/List'),
      name: 'RoleList',
      meta: {
        title: 'rolePermission',
        icon: 'EditPen',
        permissions: ['role_permission_view'],
      },
    },
    {
      path: 'edit/permission/:id(\\d+)',
      component: () => import('../views/role-permission/Permisions'),
      name: 'EditPermission',
      meta: {
        title: 'EditPermission',
        icon: 'edit',
        permissions: ['role_permission_edit'],
      },
      hidden: true,
    },
    // {
    //   path: 'articles/edit/:id(\\d+)',
    //   component: () => import('../views/articles/Edit'),
    //   name: 'EditArticle',
    //   meta: { title: 'editArticle', noCache: true },
    //   hidden: true,
    // },
    // {
    //   path: 'articles',
    //   component: () => import('../views/articles/List'),
    //   name: 'ArticleList',
    //   meta: { title: 'articleList', icon: 'list' },
    // },
    // supplier routes
    {
      path: 'suppliers',
      component: () => import('../views/supplier/List'),
      name: 'supplierList',
      meta: { title: 'supplierList', icon: 'Memo', permissions: ['supplier_view'] },
    },
    {
      path: 'suppliers/edit/:id(\\d+)',
      component: () => import('../views/supplier/components/SupplierEdit'),
      name: 'EditSupplier',
      meta: {
        title: 'supplierProfile',
        noCache: true,
        permissions: ['supplier_edit'],
      },
      hidden: true,
    },
    // clients routes
    {
      path: 'clients',
      component: () => import('../views/client/List'),
      name: 'ClientList',
      meta: { title: 'clientList', icon: 'Memo', permissions: ['client_view'] },
    },
    {
      path: 'clients/edit/:id(\\d+)',
      component: () => import('../views/client/components/ClientEdit'),
      name: 'EditClient',
      meta: {
        title: 'clientProfile',
        noCache: true,
        permissions: ['client_edit'],
      },
      hidden: true,
    },

    // subcontractors routes
    {
      path: 'subcontractors',
      component: () => import('../views/subcontractor/List'),
      name: 'SubcontractorList',
      meta: { title: 'subcontractorList', icon: 'Memo', permissions: ['subcontractor_view'] },
    },
    {
      path: 'subcontractors/edit/:id(\\d+)',
      component: () =>
        import('../views/subcontractor/components/SubcontractorEdit'),
      name: 'EditSubcontractor',
      meta: {
        title: 'subcontractorProfile',
        noCache: true,
        permissions: ['subcontractor_edit'],
      },
      hidden: true,
    },
    {
      path: 'departments',
      component: () => import('../views/department/List'),
      name: 'DepartmentList',
      meta: { title: 'DepartmentList', icon: 'Memo', permissions: ['department_view'] },
    },
    {
      path: 'departments/edit/:id(\\d+)',
      component: () => import('../views/department/components/DepartmentEdit'),
      name: 'DepartmentEdit',
      meta: {
        title: 'DepartmentEdit',
        noCache: true,
        permissions: ['department_edit'],
      },
      hidden: true,
    },
    // activity log routes
    {
      path: 'activity-log',
      component: () => import('../views/activity/List'),
      name: 'ActivityList',
      meta: {
        title: 'activityList',
        icon: 'Memo',
        permissions: ['activity_view'],
      },
    },
  ],
};

export default adminRoutes;
